export const zoomPalette = {
  grayscale: {
    100: '#FFFFFF',
    200: '#F2F2F7',
    300: '#F6F7F9',
    400: '#E4E4ED',
    500: '#BABACC',
    600: '#747487',
    700: '#4A494F',
    800: '#232333',
  },
  white: '#FFFFFF',
  black: '#232333',
  blue: {
    100: '#E7F1FD',
    300: '#D7E6F9',
    400: '#2681F2',
    500: '#0E71EB',
    700: '#0C63CE',
    800: '#2D61BA',
  },
  orange: {
    100: '#FFEBDA',
    300: '#FFD3AC',
    500: '#F26D21',
    600: '#DA621E',
    700: '#C2571A',
  },
  red: {
    300: '#E44343',
    500: '#E02828',
    700: '#CC1D1D',
  },
};

export const muiTheme = {
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          backgroundColor: zoomPalette.grayscale[200],
        },
      },
    },
  },
  typography: {
    fontFamily: [
      'Lato',
      '"Helvetica Neue"',
      'Roboto',
      'sans-serif',
    ].join(','),
    useNextVariants: true,
  },
  palette: {
    text: {
      primary: zoomPalette.black,
    },
    common: {
      white: zoomPalette.white,
      black: zoomPalette.black,
      swatch: {...zoomPalette.grayscale},
    },
    primary: {
      light: zoomPalette.blue[400],
      main: zoomPalette.blue[500],
      dark: zoomPalette.blue[700],
      altLight: zoomPalette.blue[100],
      altDark: zoomPalette.blue[300],
      swatch: {...zoomPalette.blue},
    },
    secondary: {
      light: zoomPalette.orange[600],
      main: zoomPalette.orange[500],
      dark: zoomPalette.orange[700],
      altLight: zoomPalette.orange[100],
      altDark: zoomPalette.orange[300],
      swatch: {...zoomPalette.orange},
    },
    error: {
      light: zoomPalette.red[300],
      main: zoomPalette.red[500],
      dark: zoomPalette.red[700],
      swatch: {...zoomPalette.red},
    },
  },
};

export default zoomPalette;
